<template>
  <tr v-if="value != null">
    <td class="text-xs-left" :width="this.widthRatio.toString() + '%'">
      <template v-if="icon != null">
        <v-icon color="primary"> {{ icon }} </v-icon>
      </template>
      <template v-if="name != null">
        {{ name }}
      </template>
    </td>
    <td class="text-xs-left" :width="(100 - parseInt(this.widthRatio)).toString() + '%'">
      <b>
        {{ value }}
        <template v-if="unit != null">
          {{ unit }}
        </template>
      </b>
    </td>
  </tr>
</template>

<script>
export default {
  name: "AdvancedCore",
  props: {
    name: {
      type: String,
      require: false,
      default: null,
    },
    value: {
      require: false,
      default: null,
    },
    unit: {
      type: String,
      require: false,
      default: null,
    },
    widthRatio: {
      type: Number,
      require: false,
      default: 50,
    },
    icon: {
      type: String,
      require: false,
      default: null,
    },
  },
};
</script>
